export const COLORS = {
  lightBlack: '#393955',
  black: '#333333',
  blueLight: '#6585F5',
  blue: '#3F66F3',
  blueDark: '#2346C4',
  blueHover: '#EBEFFD',
  grayBorder: '#EBEAE9',
  grayFadedBorder: '#B0B0BB',
  grayText: '#616177',
  grayMainText: '#4e4e4e',
  grayTextDisabled: '#B0B0BB',
  grayDisabled: '#D8D6D4',
  grayBackground: '#F6F4F1',
  grayLightDisabled: '#E9E3DB',
  grayHover: '#BFBFBF',
  grayPlaceholder: '#A7A7B3',
  grayButton: '#E9ECEE',
  greyDep: '#83868F',
  purple: '#393955',
  white: '#FFFFFF',
  red: '#F6564D',
  blueReference: '#E6EBF8',
  pink: '#FF34CE',
  sideBar: '#161B25',
  sideBarDarkText: '#717781',
  sideBarText: '#CDD4DA',
  green: '#25993d',
  greenLight2: '#d1f7c4',
  greenLight1: '#20c933',
  redLight2: '#ffdce5',
};

export const CORE_COLORS: { [key: string]: string } = {
  blue: '#3f66f2',
  red: '#f5564e',
  gray: '#7f7972',
  magenta: '#F33F71',
  yellow: '#fabb59',
  orange: '#ff6e2a',
  green: '#25993d',
  black: '#393955',
  pink: '#f355a8',
  purple: '#774df6',
};

export const SELECT_COLOR: { [key: string]: any } = {
  blue: '#3f66f2',
  red: '#f5564e',
  gray: '#7f7972',
  magenta: '#F33F71',
  yellow: '#fabb59',
  orange: '#ff6e2a',
  green: '#25993d',
  black: '#393955',
  pink: '#f355a8',
  purple: '#774df6',
};
